export default "__VITE_ASSET__DhFjO35W__"